/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./detailsForm.vue?vue&type=template&id=231dfb76&scoped=true&"
import script from "./detailsForm.vue?vue&type=script&lang=js&"
export * from "./detailsForm.vue?vue&type=script&lang=js&"
import style0 from "./detailsForm.vue?vue&type=style&index=0&id=231dfb76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231dfb76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardText,VCol,VContainer,VRow,VSelect,VSimpleTable,VSkeletonLoader,VTextField})
